import LibLayoutHeader from "./components/LibLayoutHeader/LibLayoutHeader";
import LibLayoutSideBar from "./components/LibLayoutSideBar/LibLayoutSideBar";
import LibDialogLogin from "./components/LibDialogLogin/LibDialogLogin";
import LibLayoutFooterBanner from "./components/LibLayoutFooterBanner/LibLayoutFooterBanner";
import LibDetailInformationDialog from "./components/LibDetailInformationDialog/LibDetailInformationDialog";
import LibLayoutRegisterBottomBanner from "./components/LibLayoutRegisterBottomBanner/LibLayoutRegisterBottomBanner";
import LibSearchInput from "./components/LibSearchInput/LibSearchInput";
import LayoutHeaderSearchCenter  from "./components/LayoutHeaderSearchCenter/LayoutHeaderSearchCenter";
import "./assets/element-variables.scss";
import "./assets/normalize.scss";
import "./assets/iconfont.css";
import LibMsgBox from "./components/LibMsgBox";
import trackDirective from "./utils/tracker.js";
import store from "./store";

// 存储组件列表
const components = [
  LibLayoutHeader,
  LibLayoutSideBar,
  LibDialogLogin,
  LibLayoutFooterBanner,
  LibDetailInformationDialog,
  LibLayoutRegisterBottomBanner,
  LibSearchInput,
  LayoutHeaderSearchCenter
];
// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function (Vue) {
  Vue.use(trackDirective);
  Vue.prototype.$store = store;
  // 判断是否安装
  if (install.installed) return;
  // 遍历注册全局组件
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};
// 判断是否是直接引入文件
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
export {
  install,
  LibMsgBox,
  LibLayoutHeader,
  LibLayoutSideBar,
  LibDialogLogin,
  LibLayoutFooterBanner,
  LibDetailInformationDialog,
  LibLayoutRegisterBottomBanner,
  LibSearchInput,
  LayoutHeaderSearchCenter
};

export default {
  install,
  LibMsgBox,
};
